import { useQuery } from '@tanstack/react-query';
import { IGetAllFeedback, IGetAllFeedbackBody } from "../../utils/types";
import { apiManager } from "../api-manager";
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';

export const getAllFeedback = async (params: IGetAllFeedbackBody) => {
  const res = await apiManager.get<IGetAllFeedback>(
    "/admin/feedback/all",
    params
  );
  return res;
};


export const useGetAllFeedback = (params: IGetAllFeedbackBody) =>
  useQuery({
    queryKey: ["get_all_feedback", params],
    queryFn: async (): Promise<IGetAllFeedback> => {
      const res = await apiClient.get(ENDPOINTS.FEEDBACK.GET_ALL, { params });
      return res.data;
    },
  });